import Navbar from "../components/Navbar";
import ViewProfile from "../components/ViewProfile";

const ViewUser = () => {
    return (
        <div className="app">
            <Navbar />
            <ViewProfile />
        </div>
    );
}

export default ViewUser;